document.addEventListener('DOMContentLoaded', () => {
  // Ensure all dependencies are fully loaded
  if (
    typeof gsap !== 'undefined' &&
    typeof SplitText !== 'undefined' &&
    typeof ScrollTrigger !== 'undefined'
  ) {
    // Register both ScrollTrigger and SplitText
    gsap.registerPlugin(SplitText, ScrollTrigger)

    // Add our safety global class to the document
    document.documentElement.classList.add('gsap-loaded')

    const initScrollSplitAnimations = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // 1. ANIMATE HEADINGS (Line by Line Fade Up on Scroll)
      const lineTargets = document.querySelectorAll('[data-gsap="split-lines"]')
      lineTargets.forEach((element) => {
        // Ensure visibility state shifts safely on init
        gsap.set(element, { opacity: 1 })

        SplitText.create(element, {
          type: 'lines',
          aria: 'auto', // Accessibility protection
          onSplit: (self) => {
            // Create an isolated timeline for this specific element triggered by scroll
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: element, // What element triggers the scroll action
                start: 'top 85%', // Triggers when the top of the element hits 85% from the top of the viewport
                toggleActions: 'play none none none', // Plays once when scrolling down close to it
              },
            })

            // Feed the timeline the animation targeting the split lines
            if (self.lines && self.lines.length > 0) {
              tl.from(self.lines, {
                y: 50,
                opacity: 0,
                duration: 1,
                ease: 'power3.out',
                stagger: 0.12,
              })
            }

            return tl
          },
        })
      })

      // 2. ANIMATE PARAGRAPHS (Cinematic Word Reveal Masking on Scroll)
      const wordTargets = document.querySelectorAll('[data-gsap="split-words"]')
      wordTargets.forEach((element) => {
        gsap.set(element, { opacity: 1 })

        SplitText.create(element, {
          type: 'words, lines',
          mask: 'words', // Wraps each word in a clipping masking node

          aria: 'auto', // screen reader accessibility compliance
          onSplit: (self) => {
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                start: 'top 88%', // Triggers slightly earlier for longer paragraph segments
                toggleActions: 'play none none none',
              },
            })

            if (self.words && self.words.length > 0) {
              tl.from(self.words, {
                yPercent: 110,
                duration: 0.85,
                ease: 'power2.out',
                stagger: 0.03,
              })
            }

            return tl
          },
        })
      })
    }

    // Run layout configurations once web fonts are finished loading metrics
    if (document.fonts) {
      document.fonts.ready.then(() => {
        initScrollSplitAnimations()
      })
    } else {
      initScrollSplitAnimations()
    }
    window.addEventListener('resize', () => {
      ScrollTrigger.refresh()
    })
  }
})
